import React from "react";
import "./Privacypolicy.css";
function Content() {
  return (
    <div className="wrap-inner-page">
      <div className="container">
        <div className="row">
          <div className="col-12 pt-4">
            <h1 className="inner-title">Privacy Policy</h1>
            <p className="inner-para">
              Gato Systems and its subsidiaries (collectively, “Gato Systems”, “us”, “our” or “we”) understand that your
              privacy is important, and we are committed to respecting your
              privacy and protecting your personal data, which is any
              information that can identify you as an individual person. This
              Privacy Policy describes how we manage and protect your personal
              data in connection with Gato Systems’s business
              activities. Please see our Terms of Use for more information about
              our online terms and policies in general.
            </p>

            <h3 className="inner-title-sm">
              YOUR ACCEPTANCE OF THIS PRIVACY POLICY
            </h3>
            <p className="inner-para">
              Please read and understand this Privacy Policy. By browsing our
              Site and using our services and expressly consenting where
              required, you agree to be bound by this Privacy Policy.
            </p>

            <h3 className="inner-title-sm">WHAT DATA DO WE COLLECT?</h3>
            <p className="inner-para">
              Gato Systems collects personal data when you register to
              access our APIs. The data we collect from you includes:
            </p>
            <ul className="inner-listing">
              <li>Full name</li>
              <li>company e-mail address</li>
              <li>
                company details, including current job role and company name
              </li>
            </ul>

            <p className="inner-para">
              We may also automatically collect information about the devices
              you use to interact with our Site. The information we
              automatically collect may include IP address, device identifier,
              web browser, and browsing information collected through Cookies,
              web beacons, pixels, clear gifs, and other similar technologies
              (collectively “Cookies and Other Tracking Technologies”) on our
              Site. We may also automatically collect information about how you
              use the Site, such as the pages viewed. The information
              automatically collected may be associated with a unique identifier
              as well as with any other personal data you have provided.
            </p>

            <h3 className="inner-title-sm">HOW WILL WE USE YOUR DATA?</h3>
            <p className="inner-para">
              Gato Systems uses your personal data to evaluate and
              improve our services, analyze the Site’s performance and
              functionality, prevent fraud, enforce our terms and conditions,
              comply with all applicable laws and corporate reporting
              obligations, enforce Gato Systems agreements, and
              accomplish other purposes you may initiate or request. In some
              situations, the collection of personal data may be required for
              the operation of the Site, or we may use it during our business
              activities, including in connection with some client services, for
              example, to provide certain services or products such as our
              market data products. We may keep any of your personal data on
              file and use it to contact you. Gato Systems and its
              service providers may use first and third-party Cookies and other
              tracking technologies, including web beacons, pixels, and other
              similar technologies to manage our Site and services and collect
              analytics about how you use them. Gato Systems and its
              service providers may collect information about whether you open
              or click any links on our Site or communications that we send to
              you. The information provided throughout this Privacy Policy about
              Cookies also applies to these other tracking technologies. Please
              refer to our Cookie Policy section in this Privacy Policy for more
              details. Our Site does not track you by collecting personal data
              about your online activities over time and across third-party
              websites or online services outside of the Gato Systems
              Site.
            </p>

            <h3 className="inner-title-sm">
              USE OF INFORMATION COLLECTED VIA MOBILE DEVICES
            </h3>
            <p className="inner-para">
              Gato Systems may use third-party service providers to
              analyze user activity to fix errors, monitor usage, and improve
              the performance of these mobile applications. For example, Gato
              Systems receives reports on some of our mobile
              applications’ aggregate usage and browsing patterns, including
              information about the type of device used, and other events
              occurring within our apps. Gato Systems also receives
              reports on certain errors occurring within mobile applications.
            </p>

            <h3 className="inner-title-sm">
              THE LEGAL BASIS BY WHICH WE PROCESS YOUR PERSONAL DATA{" "}
            </h3>
            <p className="inner-para">
              Our processing of your personal data for the purposes mentioned
              above is based:
            </p>
            <ul className="inner-listing">
              <li>
                in part, on our legitimate interests in promoting and protecting
                Gato Systems, building and maintaining relationships,
                and providing our services
              </li>

              <li>
                in part, on your consent, for example, if you register and
                create a profile for business purposes that support web
                operations such as understanding and enhancing the quality of
                your experience on our Site
              </li>

              <li>
                in part, to comply with the law, when certain information is
                necessary to satisfy our legal or regulatory obligations
              </li>
            </ul>
            <p className="inner-para">
              In those cases where the legal basis for the processing of your
              data requires your consent, we will need it expressly and in
              advance.
            </p>

            <h3 className="inner-title-sm">
              DISCLOSURE OF PERSONAL DATA: DATA RECIPIENTS AND INTERNATIONAL
              DATA TRANSFERS
            </h3>
            <p className="inner-para">
              Personal data collected during Gato Systems’s business
              activities, including in connection with some client services, as
              well as on the Site may be transferred from time to time to Gato
              Systems’s subsidiaries and affiliates and their
              personnel across our global organization. Where required by law,
              we have put in place mechanisms designed to ensure adequate
              protection of your personal data that is processed by Gato
              Systems’s subsidiaries, and affiliates. Gato Systems
              Technologies, LLC will not intentionally disclose or transfer (and
              will take reasonable steps to prevent the unauthorized or
              accidental disclosure of) your personal data to third parties
              without your consent or as otherwise permitted by law, whether for
              such third parties' own marketing purposes or otherwise, except as
              follows. In addition, we may disclose information about you:
            </p>
            <ul className="inner-listing">
              <li>If we must do so by law or legal process</li>

              <li>
                To law enforcement authorities or other government officials
              </li>

              <li>
                When we believe disclosure is necessary or appropriate to
                prevent physical harm or financial loss or in connection with an
                investigation of suspected or actual fraudulent or illegal
                activity
              </li>

              <li>
                If disclosure is necessary to protect the vital interests of a
                person
              </li>

              <li>To enforce our Terms and Conditions</li>

              <li>To protect our property, services, and legal rights</li>

              <li>
                To prevent fraud against Gato Systems, our
                subsidiaries, affiliates, and/or business partners
              </li>

              <li>
                To support auditing, compliance, legal, and corporate governance
                functions
              </li>

              <li>
                To prospective purchasers and assignees in the event our
                business, or a portion thereof, is sold or assigned and
              </li>

              <li>
                To other third parties as may be needed for the purposes set
                forth within this notice, or where we have obtained the
                appropriate authorities if required.
              </li>

              <li>To comply with all applicable laws and regulations</li>
            </ul>
            <p className="inner-para">
              In cases where you request to rectify, delete, or limit the
              processing of your personal data by us, we will also notify
              third-party recipients. We will also inform you of these
              recipients if you so request.
            </p>

            <p className="inner-para">
              In addition, we may disclose or transfer your personal data in the
              event of a reorganization, merger, sale, joint venture,
              assignment, or other transfer or disposition of all or any portion
              of our business.
            </p>

            <h3 className="inner-title-sm">
              SECURITY AND HOW WE STORE YOUR DATA
            </h3>
            <p className="inner-para">
              Gato Systems has implemented accepted standards of
              technology and operational security designed to protect personal
              data from loss, misuse, alteration, accidental, unlawful, or
              authorized destruction, from disclosure or access or use as well
              as any other unlawful forms of processing.
            </p>
            <p className="inner-para">
              Only authorized Gato Systems personnel and third-party
              service providers are given access to personal data, and these
              employees and service providers are required to treat this
              information as confidential. Despite these precautions, however,
              Gato Systems cannot guarantee that unauthorized persons
              will not obtain access to your personal data and Gato Systems,
              LLC cannot be held responsible for any actions resulting from a
              breach of security when information is supplied over the internet
              or any public computer network.
            </p>

            <h3 className="inner-title-sm">DATA RETENTION</h3>
            <p className="inner-para">
              Gato Systems retains personal data, as necessary, for the
              duration of the relevant business relationship. We may also retain
              personal data for longer than the duration of the business
              relationship should we need to retain it to protect ourselves
              against legal claims, meet regulatory requirements, use it for
              analysis or historical record-keeping, or comply with our data
              management policies. If you request that we delete your personal
              data, Gato Systems will make reasonable attempts to
              delete all instances of your data in their entirety. For requests
              for access, corrections, or deletion, please refer to the “Your
              Data Protection Rights” below of this Privacy Policy.
            </p>

            <h3 className="inner-title-sm">
              WHAT ARE YOUR DATA PROTECTION RIGHTS?
            </h3>
            <p className="inner-para">
              Where granted by applicable law, you may have the right to request
              access to the personal data that we have collected about you to
              review, modify, or request deletion of the data. You may also have
              the right to request a copy of the personal data that we have
              collected about you and to have any inaccuracies in that data
              corrected. In certain circumstances, you may also request that we
              cease processing your personal data. If this is requested, Gato
              Systems may not be able to provide the services.
            </p>
            <p className="inner-para">
              {" "}
              If you would like to make a request to access, review, or correct
              the personal data we have collected about you, or to discuss how
              we process your personal data, please contact us at{" "}
              <a href="mailto:api_support@gatosystems.com">
                api_support@gatosystems.com
              </a>
              .To help protect your privacy and security, we will take
              reasonable steps to verify your identity, such as requiring a
              password and user ID, before granting access to your personal
              data. We will make reasonable attempts to promptly investigate,
              comply with, or otherwise respond to your requests as may be
              required by applicable law. Different laws may prevent us from
              providing access to your personal data or otherwise fully
              complying with your request depending upon the circumstances and
              the request, such as where producing your information may reveal
              the identity of someone else. We will notify you of acceptance or
              denial of your specific requests, as necessary. We reserve the
              right to charge an appropriate fee for complying with your
              request, where allowed by applicable law, and /or deny your
              requests where they may be manifestly unfounded, excessive,
              objectionable, or unwarranted under applicable law.
            </p>
            <p className="inner-para">
              In addition, and where, granted by local law, you have the legal
              right to lodge a complaint with a competent data protection
              authority in your respective region.
            </p>

            <h2 className="inner-title-md">Cookie Policy</h2>
            <h3 className="inner-title-sm">
              HOW DO OUR SITES USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            </h3>
            <p className="inner-para">
              Gato Systems uses Cookies and other tracking technologies
              to identify you, your device, and your interests, remember your
              preferences, and track your use of our Site. This information is
              used to control access to certain content on our Site, protect our
              Site, and process any requests that you make of us. This helps us
              analyze data about website traffic and improve our website.
            </p>
            <p className="inner-para">
              When you visit our website for the first time, we will ask you to
              accept or reject our Cookies. Thereafter, dependent upon the
              device or location you are visiting from, after a certain period
              we may ask you to accept or reject our Cookies again. The purpose
              is to remember your preferences (e.g. name, language, etc.) for a
              certain period. In this way, you will not have to re-enter your
              preferences every time. Cookies can also be used to compile
              anonymized statistics on the browsing experience on our Site. WE
              USE THE FOLLOWING TYPES OF COOKIES:
            </p>
            <p className="inner-para">
              We use strictly necessary Cookies as they allow us to operate our
              Site, so you have access to them as requested. We use persistent
              Cookies to improve the experience of using our Site which includes
              recording your acceptance of our Cookie Policy. These are Cookies
              that are stored on your computer and not automatically deleted
              when you exit the browser (unlike session Cookies, which are
              deleted when you exit the browser or remove your cache. We use
              session Cookies to help us track your usage as described. These
              are temporary and deleted from your machine when your web browser
              is closed. The data collected by Cookies that have been placed on
              your device will be kept for as long as necessary to fulfill the
              purposes mentioned above.
            </p>

            <h3 className="inner-title-sm">
              HOW DO I REFUSE OR WITHDRAW MY CONSENT TO THE USE OF COOKIES?
            </h3>
            <p className="inner-para">
              If you do not want Cookies to be placed on your device, you can
              adjust the setting of your internet browser to reject all or some
              Cookies and to alert you when a Cookie is placed on your device.
              For further information, please refer to your browser ‘help’,
              ‘tool’, or ‘edit’ section. Please note that if you use your
              browser settings to block all Cookies, you may not be able to
              access or use all functionality of our Site.
            </p>
            <p className="inner-para">
              If you want to remove previously stored Cookies, you can manually
              delete the Cookies at any time. However, this will not prevent the
              Site from placing further Cookies on your device unless and until
              you adjust your internet browser setting as described above.
            </p>

            <h3 className="inner-title-sm">DELETE COOKIES FROM YOUR DEVICE</h3>
            <p className="inner-para">
              You can delete the Cookies you already have on your device by
              clearing the browser history or cache. This will remove Cookies
              from all websites you have visited. However, you may also lose
              some of the information you have stored (e.g. login information or
              preferences for websites).
            </p>
            <p className="inner-para">
              However, you may also lose some of the information you have stored
              (e.g., login information or preferences for websites).
            </p>

            <h3 className="inner-title-sm">BLOCKING COOKIES</h3>
            <p className="inner-para">
              It is possible to set your browser to reject Cookies on the device
              you are using by default, but in that case, you may have to
              manually set several preferences each time you visit a Site or
              page. In addition, some services and features may not work
              properly (e.g. profile login).
            </p>

            <h2 className="inner-title-md">
              Changes to Gato Systems’ Privacy Policy
            </h2>
            <p className="inner-para">
              {" "}
              By using the Site, you consent to the collection, use, and storage
              of your personal data by us in the manner described in this
              Privacy Policy and elsewhere on the Site. We reserve the right to
              amend this Privacy Policy from time to time. We will alert you to
              any such changes by updating this Privacy Policy. If we amend this
              Privacy Policy that increases our rights to use personal data
              previously collected about you, we will ask for your consent by
              email or by posting information about these changes on our Site.
            </p>

            <h3 className="inner-title-sm">HOW TO CONTACT US?</h3>

            <p className="inner-para">
              If you have any questions regarding our Privacy Policy, please
              contact us at:{" "}
              <a href="mailto:api_support@gatosystems.com">
                api_support@gatosystems.com
              </a>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
